export default __webpack_public_path__ + "static/media/Payroll_Line.38adbfa4.svg";